import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["isDisplayedHorizontally", "isOpen", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { useToken } from '@hub/design-system-base';
import { Box } from '@hub/box';
import { jsx as _jsx } from "react/jsx-runtime";
export const MainNavItemWrapper = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    isDisplayedHorizontally = false,
    isOpen = false,
    sx
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const paddingX = useToken('spacing', 'spacing-sm');
  const activeUnderline = {
    '@media (hover: hover)': {
      '& > a, & > button': {
        position: 'relative'
      },
      '& > a:before, & > button:before': {
        content: '""',
        position: 'absolute',
        left: paddingX,
        right: paddingX,
        bottom: 0,
        height: '2px',
        backgroundColor: 'licorice'
      },
      '&:first-of-type > a:before, &:first-of-type > button:before': {
        left: '0'
      },
      '&:last-of-type > a:before, &:last-of-type > button:before': {
        right: '8'
      }
    }
  };
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    as: "li"
  }, props), {}, {
    ref: ref,
    sx: _objectSpread(_objectSpread({
      whiteSpace: 'nowrap',
      height: 'size-full'
    }, isDisplayedHorizontally ? _objectSpread(_objectSpread({
      '& > a, & > button': {
        paddingLeft: 'spacing-sm',
        paddingRight: 'spacing-sm'
      },
      '&:first-of-type > a, &:first-of-type > button': {
        paddingLeft: 0
      }
    }, isOpen && activeUnderline), {}, {
      _hover: activeUnderline
    }) : {}), sx),
    "data-id": "tabs_main-nav-item-wrapper_MainNavItemWrapper_Box"
  }));
});
MainNavItemWrapper.displayName = 'MainNavItemWrapper';